import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import { dateOnlyFormatted } from "../../../../../utils/systemSettings";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import useNavigation from "../../../../../utils/useNavigation";
import { generalActions } from "../../../../../store/actions";
import { apiCall } from "../../../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../../../store/services/URL";
import clientService from "../../../../../store/services/clients.service";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import TextArea from "../../../textarea/Textarea";
import riskService from "../../../../../store/services/risks.service";
import DropDown from "../../../dropdown/DropdownFluent";
import {
  riskStatus,
  changeRequestTypes,
  getRiskSeverityStatus,
  getRiskSeverityColorClass,
} from "../../../../../helpers/utils";
import userService from "../../../../../store/services/user.service";
import { updateRiskRequest } from "../../../../../store/actions/risks.actions";
import { createRiskRequest } from "../../../../../store/actions/risks.actions";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const RiskRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    parentType,
    projectId,
    programId,
    sortRiskRequest,
    portfolioId,
    updateFlag,
    columnConfig,
    overviewType,
    dashboardFilterSetProjectId,
    dashboardFilterSetProjectName,
    loadingSkeleton,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [isEditRecord, setIsEditRecord] = useState(null);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const [setting] = useState(settings);
  const popoverRef = useRef(null);
  const [resources, setResources] = useState(null);
  const [ownerId, setOwnerId] = useState(null);
  const [clients, setClients] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });
  const scopeNameRef = useRef(null);
  const budgetInputRef = useRef();
  const startDateInputRef = useRef(null);
  const managerRef = useRef(null);
  const typeRef = useRef(null);
  const statusRef = useRef(null);

  const dispatch = useDispatch();

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.client) {
      data.clientId = data.client.id;
    } else {
      delete data.client;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
    } else {
      delete data.portfolio;
    }
    if (data.program) {
      data.programId = data.program.id;
    } else {
      delete data.program;
    }
    if (data.project) {
      data.projectId = data.project.id;
    } else {
      data.projectId = null;
    }
    if (data.owner) {
      data.ownerId = data.owner.id;
    }
    if (data.changeRequest) {
      data.changeRequestId = data.changeRequest.id;
    }
    if (data.dateIdentified === "") {
      data.dateIdentified = moment.utc().format();
    }

    delete data.actual;
    delete data.accural;
    delete data.bac;
    delete data.etc;
    delete data.isFlagged;
    delete data.dateCreated;

    const payload = {};
    payload.parent = parentType;
    if (parentType === "Project") {
      payload.parentID = projectId;
      payload.parent = "Project";
    }
    if (parentType === "Program") {
      payload.parentID = programId;
      payload.parent = "Program";
    }
    if (parentType === "Portfolio") {
      payload.parentID = portfolioId;
      payload.parent = "Portfolio";
    }

    if (parentType === "Project") {
      data.projectId = projectId;
    } else if (parentType === "Program") {
      data.programId = programId;
    } else if (parentType === "Portfolio") {
      data.portfolioId = portfolioId;
    }

    if (data.name && data.projectId) {
      if (data.id) {
        dispatch(
          updateRiskRequest({
            id: isEditRecord.name.project.id,
            ...payload,
            payload: { rId: isEditRecord.name.id, payload: data },
          })
        );
      } else {
        dispatch(createRiskRequest({ payload: data, ...payload }));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.name) errors["scopeName"] = `The Name field is required.`;
      if (!data.project) errors["projectId"] = `The Project field is required.`;
      setFormErrors(errors);
      if (!data.name) {
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      } else if (!data.project) {
        return dispatch(
          generalActions.showToast({
            title: "Project is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      const payload = {
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      };
      if (parentType === "Risk") payload.parent = "Risk";
      if (parentType === "Project") {
        payload.id = projectId;
        payload.parent = "Project";
      }
      if (parentType === "Program") {
        payload.id = programId;
        payload.parent = "Program";
      }
      if (parentType === "Portfolio") {
        payload.id = portfolioId;
        payload.parent = "Portfolio";
      }
      sortRiskRequest(payload);
    }
  }, [sortingCriteria]);

  const getType = (type) => {
    switch (type) {
      case 0:
        return "Scope";
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({
        name: "",
        client: null,
        portfolio: null,
        program: null,
        project: null,
        owner: "",
        status: 0,
        type: 0,
        description: "",
        changeRequest: "",
        budget: 0,
        dateImpact: "",
        dateResolved: "",
        dateIdentified: "",
      });
      setSortedData(tempData);
    }
  }, [data]);

  const getStatus = (status) => {
    switch (status) {
      case 0:
        return "Identified";
      case 1:
        return "Opened";
      case 2:
        return "Monitoring";
      case 3:
        return "Escalated";
      case 4:
        return "Impacted";
      case 5:
        return "Closed";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handlePortfolioRedirect = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo(
          "Portfolios",
          item.portfolio.id,
          item.portfolio.name,
          "overview"
        );
      } else {
        // Already in portfolio context, just navigate
        history.push(`/portfolio/${item.portfolio.id}/overview`);
      }
    }
  };

  const handleProgramRedirect = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        history.push(`/program/${item.program.id}/overview`);
      }
    }
  };

  const handleProjectRedirect = (item) => {
    if (overviewType === "Dashboard") {
      dashboardFilterSetProjectId(item.project.id);
      dashboardFilterSetProjectName(item.project.name);
      return;
    }
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "textarea" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      error["scopeName"] = ``;
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (!data.name?.owner) {
        data.name.owner = {};
      }
      data.name.owner.name = value.label;
      data.name.owner.id = value.value;

      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = setRequestStatus(value);
      setIsEditRecord(data);
    } else if (type === "phase") {
      data.name.phase = value;
      setIsEditRecord(data);
    } else if (type === "project") {
      error["projectId"] = ``;
      setFormErrors(error);
      if (!value) {
        data.name.project = null;
      } else {
        if (!data.name?.project) {
          data.name.project = {};
        }
        data.name.project.name = value.label;
        data.name.project.id = value.value;
      }
      setIsEditRecord(data);
    } else if (type === "client") {
      if (!value) {
        data.name.client = null;
      } else {
        if (!data.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      }
      data.name.project = null;
      data.name.portfolio = null;
      data.name.program = null;
      setIsEditRecord(data);
    } else if (type === "changeRequest") {
      if (!value) {
        data.name.changeRequest = null;
      } else {
        if (!data.name?.changeRequest) {
          data.name.changeRequest = {};
        }
        data.name.changeRequest.name = value.label;
        data.name.changeRequest.id = value.value;
      }
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      if (!value) {
        data.name.portfolio = null;
      } else {
        if (!data.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      }
      data.name.program = null;
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "program") {
      if (!value) {
        data.name.program = null;
      } else {
        if (!data.name?.program) {
          data.name.program = {};
        }
        data.name.program.name = value.label;
        data.name.program.id = value.value;
      }
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "priority") {
      data.name.priority = setRequestPriority(value);
      setIsEditRecord(data);
    } else if (type === "budget") {
      data.name.budget = value;
      setIsEditRecord(data);
    } else if (type === "description") {
      data.name.description = value;
      setIsEditRecord(data);
    } else if (type === "type") {
      data.name.type = setRequestType(value);
      setIsEditRecord(data);
    } else if (type === "dateIdentified") {
      data.name.dateIdentified = value;
      setIsEditRecord(data);
    } else if (type === "dateResolved") {
      data.name.dateResolved = value;
      setIsEditRecord(data);
    } else if (type === "dateImpact") {
      data.name.dateImpact = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (overviewType === "Dashboard") {
      return;
    }

    if (index === data.length && type !== "scope") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "scope":
        scopeNameRef?.current.focus();
        break;
      case "budget":
        budgetInputRef?.current?.focus();
        break;
      case "manager":
        managerRef?.current?.focus();
        break;
      case "type":
        typeRef?.current?.focus();
        break;
      case "status":
        statusRef?.current?.focus();
        break;
      default:
        break;
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const setRequestType = (type) => {
    switch (type) {
      case "Scope":
        return 0;
      case "Schedule":
        return 1;
      case "Budget":
        return 2;
      case "Quality":
        return 3;
      case "Resource":
        return 4;
      default:
        return 0;
    }
  };

  const getRequestStatus = (type) => {
    switch (type) {
      case 0:
        return "Identified";
      case 1:
        return "Opened";
      case 2:
        return "Monitoring";
      case 3:
        return "Escalated";
      case 4:
        return "Impacted";
      case 5:
        return "Closed";
      default:
        return "";
    }
  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "Identified":
        return 0;
      case "Opened":
        return 1;
      case "Monitoring":
        return 2;
      case "Escalated":
        return 3;
      case "Impacted":
        return 4;
      case "Closed":
        return 5;
      default:
        return 0;
    }
  };

  const getRequestType = (type) => {
    switch (type) {
      case 0:
        return "Scope";
      case 1:
        return "Schedule";
      case 2:
        return "Budget";
      case 3:
        return "Quality";
      case 4:
        return "Resource";
      default:
        return 0;
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Budget";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.program) {
      queryParam = `?programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.program) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio && isEditRecord?.name?.program) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (
      isEditRecord?.name?.client &&
      isEditRecord?.name?.portfolio &&
      isEditRecord?.name?.program
    ) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Program") {
      queryParam = queryParam + `&programId=${programId}`;
    } else if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client.id}&portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: isEditRecord?.name?.client?.id, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (isEditRecord?.name?.client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({
      name: "",
      client: null,
      portfolio: null,
      program: null,
      project: null,
      owner: null,
      status: 0,
      type: 0,
      impact: 0,
      description: "",
      changeRequest: "",
      budget: 0,
      dateImpact: "",
      dateResolved: "",
      dateIdentified: "",
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const searchChangRequestHandler = (value) => {
    if (value === "") {
      setChangeRequests([]);
      return;
    }
    // if (value) {
    riskService
      .searchChangeRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setChangeRequests(transformedArray);
      })
      .catch(() => {
        setChangeRequests([]);
      });
    // }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Name":
        return (
          <TableCell>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add Risk/Issue name"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={scopeNameRef}
                    errorMessage={formErrors.scopeName}
                    displayErrorMessage={false}
                  />
                ) : (
                  <span
                    className="text-truncate"
                    onClick={() => handleIsEdiRecord(index, "scope")}
                  >
                    {item?.id ? (
                      item.name
                    ) : (
                      <div className="d-flex _add_btn">
                        <PlusIcon />
                        Add
                      </div>
                    )}
                  </span>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        if (parentType === "Client") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : item.client ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "client")}
          >
            <span onClick={() => handleClientRedirect(item)}>
              {item.client?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "client")} />
        );
      case "Portfolio":
        if (parentType === "Portfolio") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              CustomClass="ModalAvatarSearch"
              persona={true}
              searchText={searchPortfolioHandler}
              SelectText="portfolio"
              options={portfolioOptions}
              defaultVal={
                isEditRecord.name.portfolio?.name
                  ? {
                      label: isEditRecord.name.portfolio.name,
                      value: isEditRecord.name.portfolio.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "portfolio")}
            />
          </TableCell>
        ) : item.portfolio ? ( // Changed from item.program to item.portfolio
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "portfolio")}
          >
            <span onClick={() => handlePortfolioRedirect(item)}>
              {item.portfolio?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "portfolio")} />
        );
      case "Program":
        if (parentType === "Program") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="program"
              searchText={searchProgramHandler}
              options={programs}
              defaultVal={
                isEditRecord.name.program?.name
                  ? {
                      label: isEditRecord.name.program.name,
                      value: isEditRecord.name.program.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "program")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : item.program ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "program")}
          >
            <span onClick={() => handleProgramRedirect(item)}>
              {item.program?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "program")} />
        );
      case "Project":
        return isEditing ? (
          <TableCell>
            <CustomSelect
              SelectText="project"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={
                isEditRecord.name.project?.name
                  ? {
                      label: isEditRecord.name.project.name,
                      value: isEditRecord.name.project.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "project")}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.projectId}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : item.project ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "project")}
          >
            <span onClick={() => handleProjectRedirect(item)}>
              {item.project?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "project")} />
        );
      case "Description":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "description")}
          >
            {isEditing ? (
              <TextArea
                textAreaFieldSize="textArea_medium"
                placeholder="description"
                value={isEditRecord.name.description}
                onChange={(e) => handleInputChange(e, "description")}
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.description}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.description}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Change Request":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "changeRequest")}>
            {isEditing ? (
              <CustomSelect
                searchText={searchChangRequestHandler}
                SelectText="change request"
                options={changeRequests}
                defaultVal={
                  isEditRecord.name.changeRequest?.name
                    ? {
                        label: isEditRecord.name.changeRequest?.name,
                        value: isEditRecord.name.changeRequest?.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "changeRequest")}
              />
            ) : item.changeRequest ? (
              item.changeRequest.name
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Type":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "budget")}>
            {" "}
            {/* Note: This seems like a typo; should it be "type"? */}
            <p>
              {isEditing ? (
                <DropDown
                  label="Type"
                  showLabel={false}
                  options={changeRequestTypes}
                  defaultVal={getRequestType(isEditRecord.name.type)}
                  onChange={(e) => handleInputChange(e, "type")}
                  isInlineFocus={true}
                />
              ) : (
                item?.id && getType(item.type)
              )}
            </p>
          </TableCell>
        );
      case "Prime":
        return (
          <TableCell
            role="gridcell"
            onClick={() => handleIsEdiRecord(index, "manager")}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="prime"
                searchText={searchHandler}
                options={resources && resources.length ? resources : []}
                defaultVal={
                  isEditRecord.name.owner?.name
                    ? {
                        label: isEditRecord.name.owner.name,
                        value: isEditRecord.name.owner.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "manager")}
                creatable={true}
                setCreated={setOwnerId}
                CustomClass="ModalAvatarSearch"
                handleInputChange={handleInputChange}
              />
            ) : item.owner ? (
              <TableCellLayout
                media={
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.owner ? item.owner.name : ""}
                        image={{
                          src: item.owner.image ? item.owner.image : "",
                        }}
                      />
                    }
                    AvatarId={item.owner?.id}
                    AvatarName={item.owner?.name}
                    AvatarImage={item.owner?.image}
                    AvatarDesignation={item.owner?.title}
                    AvatarEmail={item.owner?.email}
                    AvatarPhone={item.owner?.phoneNumber}
                    AvatarIsExternal={item.owner?.isExternal}
                  />
                }
              >
                {item.owner ? item.owner.name : ""}
              </TableCellLayout>
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Probability":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "probability")}>
            {item.probability ? item.probability : ""}
          </TableCell>
        );
      case "Impact":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "impact")}>
            {item.impact ? item.impact : ""}
          </TableCell>
        );
      case "Severity":
        return (
          <TableCell>
            <Tooltip
              withArrow
              positioning="after"
              content={{
                children: <>{item.severity}</>,
                className: "ListingTooltip",
              }}
              relationship="description"
            >
              <p
                className={`pill w-100 ${getRiskSeverityColorClass(
                  item.severity
                )}`}
              >
                {getRiskSeverityStatus(item.severity)}
              </p>
            </Tooltip>
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            <p
              className={
                isEditing
                  ? ""
                  : !item?.id
                  ? ""
                  : `pill ${
                      item.status === 0 || item.status === 1
                        ? "OnTrack"
                        : item.status === 2
                        ? "OffTrack"
                        : item.status === 3 || item.status === 4
                        ? "AtRisk"
                        : "Completed"
                    }`
              }
            >
              {isEditing ? (
                <DropDown
                  label="Status"
                  showLabel={false}
                  options={riskStatus}
                  defaultVal={getRequestStatus(isEditRecord.name.status)}
                  onChange={(e) => handleInputChange(e, "status")}
                  isInlineFocus={true}
                />
              ) : (
                item?.id && getStatus(item.status)
              )}
            </p>
          </TableCell>
        );
      case "Date Identified":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "dateIdentified")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.dateIdentified}
                type="date"
                handleChange={(value) =>
                  handleInputChange(value, "dateIdentified")
                }
                ref={startDateInputRef}
              />
            ) : item.dateIdentified ? (
              dateOnlyFormatted(setting, item.dateIdentified)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Date Resolved":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "dateResolved")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.dateResolved}
                type="date"
                handleChange={(value) =>
                  handleInputChange(value, "dateResolved")
                }
                ref={startDateInputRef}
              />
            ) : item.dateResolved ? (
              dateOnlyFormatted(setting, item.dateResolved)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Date of Impact":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "dateImpact")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.dateImpact}
                type="date"
                handleChange={(value) => handleInputChange(value, "dateImpact")}
                ref={startDateInputRef}
              />
            ) : item.dateImpact ? (
              dateOnlyFormatted(setting, item.dateImpact)
            ) : (
              ""
            )}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const RiskRowSkeleton = ({ columnConfig, parentType, rowCount = 5 }) => {
    const sortedColumnConfig = [...columnConfig].sort(
      (a, b) => a.order - b.order
    );

    const visibleColumns = sortedColumnConfig.filter((col) => {
      if (col.label === "Client" && parentType === "Client") return false;
      if (col.label === "Portfolio" && parentType === "Portfolio") return false;
      if (col.label === "Program" && parentType === "Program") return false;
      return col.isVisible;
    });

    const skeletonRows = Array(rowCount)
      .fill()
      .map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`} className="skeleton-row">
          {visibleColumns.map((col, colIndex) => (
            <TableCell
              key={`skeleton-cell-${rowIndex}-${colIndex}`}
              className="skeleton-cell"
            >
              <Skeleton width={100} />
            </TableCell>
          ))}
        </TableRow>
      ));

    return <>{skeletonRows}</>;
  };
  const styles = useStyles();

  if (loadingSkeleton) {
    return (
      <RiskRowSkeleton columnConfig={columnConfig} parentType={parentType} />
    );
  }
  return sortedData
    .filter((item) => !(overviewType === "Dashboard" && !item.id))
    .map((item, index) => (
      <TableRow
        key={item.id || index}
        ref={popoverRef}
        style={item.isIssue ? { backgroundColor: "#FAE6E7" } : {}}
      >
        {sortedColumnConfig
          .filter((col) => col.isVisible)
          .map((col) => renderTableCell(item, index, col))}
      </TableRow>
    ));
};

export default RiskRow;
